<template>
  <span
    class="flex justify-center items-center"
    :class="[{ 'p-0.5 bg-upgrade rounded-full': contained }, size]"
  >
    <Iconic
      slug="crown"
      :class="
        contained ? 'w-full h-full text-white' : 'w-full h-full text-upgrade'
      "
    />
  </span>
</template>

<script>
import Iconic from '@/components/Iconic'

export default {
  components: { Iconic },

  props: {
    contained: { type: Boolean, default: true },
    size: { type: String, default: 'w-5 h-5' },
  },
}
</script>
